import React from "react";

const ShimmerUi = () => {
  return (
    <div className="bg-black p-4 md:mx-20 mx-6 my-8 opacity-90 overflow-x-auto">
      <button className="rounded-lg animate-pulse w-52 h-9 bg-gray-500"></button>
      <div className="flex">
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
        <div className="flex-shrink-0">
          <div className="animate-pulse mt-4 mr-3 w-40 h-52 bg-gray-500 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerUi;
